import script from "./ComparePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComparePage.vue?vue&type=script&setup=true&lang=ts"

import "./ComparePage.vue?vue&type=style&index=0&id=45d81624&lang=scss"

const __exports__ = script;

export default __exports__